import { TLC_CONSTANTS } from "../lib/tlc-constants";

export const LS2PAC_CONSTANTS = {
	loginIFrameUrl:       'login_iframe',
	rememberMeCookieName: 'SPRING_SECURITY_REMEMBER_ME_COOKIE',
	Events:               {
		onSearch:                                   "search",
		onBrowse:                                   "browse",
		onHome:                                     "home",
		onAdvancedSearch:                           "advancedSearch",
		onAdvancedSearchBoolean:                    "advancedSearchBoolean",
		onAdvancedSearchReserved:                   "advancedSearchReserved",
		onFireAdvancedSearch:                       "onFireAdvancedSearch",
		onFireReservesSearch:                       "onFireReservesSearch",
		onShowAdvancedSearchSubView:                "onShowAdvancedSearchSubView",
		onGetReserveSearchOptions:                  "onGetReserveSearchOptions",
		onGetReserveSearchOptionsResponse:          "onGetReserveSearchOptionsResponse",
		onSetCurrentReserveSearchFilters:           "onSetCurrentReserveSearchFilters",
		onSetCurrentReserveSearchFiltersResponse:   "onSetCurrentReserveSearchFiltersResponse",
		onGetCurrentReserveSearchFilters:           "onGetCurrentReserveSearchFilters",
		onGetCurrentReserveSearchFiltersResponse:   "onGetCurrentReserveSearchFiltersResponse",
		onMyAccount:                                "myaccount",
		onMyAccountDropDownActivator:               "onMyAccountDropDownActivator",
		onGetBranchLimits:                          "onGetBranchLimits",
		onGetBranchLimitsResponse:                  "onGetBranchLimitsResponse",
		onGetFacetResultsResponse:                  "onGetFacetResultsResponse",
		onGetMoreFacetResults:                      "onGetMoreFacetResults",
		onGetMoreFacetResultsResponse:              "onGetMoreFacetResultsResponse",
		onAddFacetFilterToResults:                  "onAddFacetFilterToResults",
		onRemoveFacetFilter:                        "onRemoveFacetFilter",
		onChangeBranchLimits:                       "onChangeBranchLimits",
		onSortSearch:                               "onSortSearch",
		onChangeWorldBookDatabase:                  "onChangeWorldBookDatabase",
		onGetIsAmazonJacket:                        "onGetIsAmazonJacket",
		onGetIsAmazonJacketResponse:                "onGetIsAmazonJacketResponse",
		onShowFullDetails:                          "onShowFullDetails",
		onViewNullResource:                         "onViewNullResource",
		onViewResource:                             "onViewResource",
		onBackToSearch:                             "onBackToSearch",
		onBackToBrowse:                             "onBackToBrowse",
		onBackToMyAccount:                          "onBackToMyAccount",
		onChangeResultsView:                        "onChangeResultsView",
		onGetMarcRecord:                            "onGetMarcRecord",
		onGetMarcRecordResponse:                    "onGetMarcRecordResponse",
		onGetFullDetailsFromMarcRecord:             "onGetFullDetailsFromMarcRecord",
		onGetFullDetailsFromMarcRecordResponse:     "onGetFullDetailsFromMarcRecordResponse",
		onGetSyndeticsContent:                      "onGetSyndeticsContent",
		onGetSyndeticsContentResponse:              "onGetSyndeticsContentResponse",
		onGetSyndeticsReviews:                      "onGetSyndeticsReviews",
		onGetSyndeticsReviewsResponse:              "onGetSyndeticsReviewsResponse",
		onLogin:                                    "onLogin",
		onPromptForLogin:                           "onPromptForLogin",
		onLoginResponse:                            "onLoginResponse",
		onLogout:                                   "onLogout",
		onLogoutResponse:                           "onLogoutResponse",
		onGetCurrentUser:                           "onGetCurrentUser",
		onGetCurrentUserResponse:                   "onGetCurrentUserResponse",
		onAddTag:                                   "onAddTag",
		onAddTagResponse:                           "onAddTagResponse",
		onDeleteTag:                                "onDeleteTag",
		onDeleteTagResponse:                        "onDeleteTagResponse",
		onGetSummaryContent:                        "onGetSummaryContent",
		onGetSummaryContentResponse:                "onGetSummaryContentResponse",
		onGetSpellingSuggestions:                   "onGetSpellingSuggestions",
		onGetSpellingSuggestionsResponse:           "onGetSpellingSuggestionsResponse",
		onWindowResize:                             "onWindowResize",
		onGetAccountSummary:                        "onGetAccountSummary",
		onGetDependentAccountSummaries:							"onGetDependentAccountSummaries",
		onGetAccountSummaryResponse:                "onGetAccountSummaryResponse",
		onGetDependentAccountSummariesResponse:     "onGetDependentAccountSummariesResponse",
		onRenewLoans:                               "onRenewLoans",
		onRenewLoansResponse:                       "onRenewLoansResponse",
		onCancelHolds:                              "onCancelHolds",
		onCancelHoldsResponse:                      "onCancelHoldsResponse",
		onSuspendHolds:                             "onSuspendHolds",
		onSuspendHoldsResponse:                     "onSuspendHoldsResponse",
		onUnsuspendHolds:                           "onUnsuspendHolds",
		onUnsuspendHoldsResponse:                   "onUnsuspendHoldsResponse",
		onCancelBookings:                           "onCancelBookings",
		onCancelBookingsResponse:                   "onCancelBookingsResponse",
		onChangeBranchLimitsFromAdvancedSearch:     "onChangeBranchLimitsFromAdvancedSearch",
		onFinePaymentUpdate:                        "onFinePaymentUpdate",
		onOpenSaveSearch:                           "onOpenSaveSearch",
		onSaveSearch:                               "onSaveSearch",
		onSaveSearchResponse:                       "onSaveSearchResponse",
		onObrShowForm:                              "onObrShowForm",
		onObrHideForm:                              "onObrHideForm",
		onObrSubmitForm:                            "onObrSubmitForm",
    onObrSubmitFormResponse:                    "onObrSubmitFormResponse",
		onOpenAddToList:                            "onOpenAddToList",
		onOpenSelectDateRange:                      "onOpenSelectDateRange",
		onGetCurrentSearch:                         "onGetCurrentSearch",
		onGetCurrentSearchResponse:                 "onGetCurrentSearchResponse",
		onGetLandingPageConfig:                     "onGetLandingPageConfig",
		onGetLandingPageConfigResponse:             "onGetLandingPageConfigResponse",
		onUpdateLandingPageConfig:                  "onUpdateLandingPageConfig",
		onUpdateLandingPageConfigResponse:          "onUpdateLandingPageConfigResponse",
		onGetStaticConfigLists:                     "onGetStaticConfigLists",
		onGetStaticConfigListsResponse:             "onGetStaticConfigListsResponse",
		onGetDynamicConfigLists:                    "onGetDynamicConfigLists",
		onGetDynamicConfigListsResponse:            "onGetDynamicConfigListsResponse",
		onGetDynamicLists:                          "onGetDynamicLists",
		onGetDynamicListsResponse:                  "onGetDynamicListsResponse",
		onGetFullListsForBibExport:                 "onGetFullListsForBibExport",
		onGetFullListsForBibExportResponse:         "onGetFullListsForBibExportResponse",
		onGetFullListsForBibExportUpdate:           "onGetFullListsForBibExportUpdate",
		onRequest:                                  "onRequest",
		onRequestResponse:                          "onRequestResponse",
		onShowBatchRequestsDialog:                  "onShowBatchRequestsDialog",
		onCloseLogin:                               "onCloseLogin",
		onSubmitRequest:                            "onSubmitRequest",
		onUpdateContactInformation:                 "onUpdateContactInformation",
		onUpdateContactInformationResponse:         "onUpdateContactInformationResponse",
		onUpdatePin:                                "onUpdatePin",
		onUpdatePinResponse:                        "onUpdatePinResponse",
		onCreateEZLogin:                            "onCreateEZLogin",
		onCreateEZLoginResponse:                    "onCreateEZLoginResponse",
		onUnlinkGoogleAccount:                      "onUnlinkGoogleAccount",
		onUnlinkGoogleAccountResponse:              "onUnlinkGoogleAccountResponse",
		onUpdateEZUsername:                         "onUpdateEZUsername",
		onUpdateEZUsernameResponse:                 "onUpdateEZUsernameResponse",
		onUpdateEZPassword:                         "onUpdateEZPassword",
		onUpdateEZPasswordResponse:                 "onUpdateEZPasswordResponse",
		onGetAllHolds:                              "onGetAllHolds",
		onGetAllHoldsResponse:                      "onGetAllHoldsResponse",
		onGetAllCurrentLoans:                       "onGetAllCurrentLoans",
		onGetAllCurrentLoansResponse:               "onGetAllCurrentLoansResponse",
		onGetAllFines:                              "onGetAllFines",
		onGetAllFinesResponse:                      "onGetAllFinesResponse",
		onGetAllBookings:                           "onGetAllBookings",
		onGetAllBookingsResponse:                   "onGetAllBookingsResponse",
		onGetAllLoanHistoryRange:                   "onGetAllLoanHistoryRange",
		onGetAllLoanHistoryRangeResponse:           "onGetAllLoanHistoryRangeResponse",
		onGetObrConfig:                             "onGetObrConfig",
    onGetObrConfigResponse:                     "onGetObrConfigResponse",
		onGetContactInfoPageConfig:                 "onGetContactInfoPageConfig",
		onGetContactInfoPageConfigResponse:         "onGetContactInfoPageConfigResponse",
		onPlaceBookings:                            "onPlaceBookings",
		onPlaceBookingReturn:                       "onPlaceBookingReturn",
		onGetStoredImagesByLogo:                    "onGetStoredImagesByLogo",
		onGetStoredImagesByLogoResponse:            "onGetStoredImagesByLogoResponse",
		onRemoveStoredImage:                        "onRemoveStoredImage",
		onRemoveStoredImageResponse:                "onRemoveStoredImageResponse",
		onUpdateLogo:                               "onUpdateLogo",
		onUpdateLogoResponse:                       "onUpdateLogoResponse",
		onClickPrintAccountData:                    "onClickPrintAccountData",
		onSwitchSearchDatabase:                     "onSwitchSearchDatabase",
		onGetDatabaseSearchCount:                   "onGetDatabaseSearchCount",
		onShowLandingPage:                          "onShowLandingPage",
		onAddStaticResourceList:                    "onAddStaticResourceList",
		onAddDynamicResourceList:                   "onAddDynamicResourceList",
		onRemoveResourceList:                       "onRemoveResourceList",
		onAddNewReleases:                           "onAddNewReleases",
		onForgotPassword:                           "onForgotPassword",
		onForgotPasswordResponse:                   "onForgotPasswordResponse",
		onForgotUsername:                           "onForgotUsername",
		onClearSearch:                              "onClearSearch",
		onClickAvailabilityLink:                    "onClickAvailabilityLink",
		onClickDownloadLink:                        "onClickDownloadLink",
		onClickMoreOptionsLink:                     "onClickMoreOptionsLink",
		onAttemptEResourceCheckout:                 "onAttemptEResourceCheckout",
		onEResourceCheckout:                        "onEResourceCheckout",
		onEResourceCheckoutResponse:                "onEResourceCheckoutResponse",
		onEResourcePlaceHold:                       "onEResourcePlaceHold",
		onEResourcePlaceHoldResponse:               "onEResourcePlaceHoldResponse",
		onEResourceRenew:                           "onEResourceRenew",
		onEResourceRenewResponse:                   "onEResourceRenewResponse",
		onEResourceReturn:                          "onEResourceReturn",
		onEResourceReturnResponse:                  "onEResourceReturnResponse",
		onRedownloadFormatSelected:                 "onRedownloadFormatSelected",
		onSpeech:                                   "onSpeech",
		updateDigitalLoanEvent:                     "updateDigitalLoanEvent",
		updateDigitalLoanEventResponse:             "updateDigitalLoanEventResponse",
		onGetEResourceAvailabilityResponse:         "onGetEResourceAvailabilityResponse",
		onGetEResourceFormatResponse:               "onGetEResourceFormatResponse",
		onAttemptEResourceFormatSelection:          "onAttemptEResourceFormatSelection",
		onAttemptOverdriveDownload:                 "onAttemptOverdriveDownload",
		onAttemptEResourceRenew:                    "onAttemptEResourceRenew",
		onAttemptEResourceReturn:                   "onAttemptEResourceReturn",
		onTimeout:                                  "onTimeout",
		onTimeoutCancel:                            "onTimeoutCancel",
		onSetAudience:                              "onSetAudience",
		onGetAudience:                              "onGetAudience",
		onGetAudienceResponse:                      "onGetAudienceResponse",
		onGetReadingLevelOptions:                   "onGetReadingLevelOptions",
		onGetReadingLevelOptionsResponse:           "onGetReadingLevelOptionsResponse",
		onGetReadingLevelSearchFilters:             "onGetReadingLevelSearchFilters",
		onGetReadingLevelSearchFiltersResponse:     "onGetReadingLevelSearchFiltersResponse",
		onResetReadingLevelFilter:                  "onResetReadingLevelFilter",
		onShowVirtualShelf:                         "onShowVirtualShelf",
		onShowVirtualShelfResponse:                 "onShowVirtualShelfResponse",
		onGetVirtualShelfResources:                 "onGetVirtualShelfResources",
		onGetVirtualShelfResourcesResponse:         "onGetVirtualShelfResourcesResponse",
		onGoToFullDetailsFromVirtualShelf:          "onGoToFullDetailsFromVirtualShelf",
		onTeachingBooksButtonClick:                 "onTeachingBooksButtonClick"
	},
	Ids:                  {
		mainPage:               "mainPage",
		loginInfoSection:       "loginInfoSection",
		dialogContainer:        "dialogContainer",
		tooltip:                "tooltip",
		mainLoader:             "mainLoader",
		mainContent:            "mainContent",
		branchLimitControl:     "branchLimitControl",
		selectAllOrNoneControl: "selectAllOrNoneControl",
		loadingProgress:        "loadingProgress",
		landingPage:            "landingPage",
		writeReviewDialog:      "writeReviewDialog",
		successMessage:         "successMessage",
		ObrPage:                {
			navigation:              "obrpage_navigation",
			obrPageView:             "obrPageView",
            obrUrl:					 "obrUrl"
		},
		printProgressbar:       "printProgressbar",
		hiddenIFrameDownloader: "hiddenIFrameDownloader",
		Login:                  {
			ezLoginForm:             "ezLoginForm",
			hostSystemLoginForm:     "hostSystemLoginForm",
			loginForm:               "loginForm",
			loginErrorMessage:       "loginErrorMessage",
			externalPortals:         "externalPortals",
			refreshNotification:     "refreshNotification",
			loginFormForgotPassword: "loginFormForgotPassword",
			hiddenLoginIFrame:       "hiddenLoginIFrame"
		},
		Header:                 {
			mainHeader:                 "mainHeader",
			header_LibraryName:         "header_LibraryName",
			header_LibraryLogo:         "header_LibraryLogo",
			searchForm:                 "header_searchForm",
			searchInput:                "header_searchInput",
			searchSuggestions:          "header_searchSuggestions",
			header_clearSearch:         "header_clearSearch",
			headerLoginLink:            "headerLoginLink",
			myAccountControl:           "myAccountControl",
			myAccountDropDown:          "myAccountDropDown",
			myAccountDropDownActivator: "myAccountDropDownActivator",
			adfsHeaderLogoutLink:       "adfsHeaderLogoutLink"
		},
		Footer:                 {
			mainFooter:               "mainFooter",
			languageSelectionControl: "languageSelectionControl"
		},
		Requests:               {
			locationSelector:      "requestsLocationSelector",
			batchLocationSelector: "batchRequestLocationSelector",
			bookFrom:              "bookFrom",
			bookTo:                "bookTo",
			requestsForm:          "requestsForm",
			titleLevelOption:      "titleLevelOption",
			itemLevelOption:       "itemLevelOption",
			bookingsOption:        "bookingsOption",
			requestCopies:         "requestCopies",
			requestOptionsDL:      "requestOptionsDL",
			requestItemDD:         "requestItemDD",
			requestBookingsDD:     "requestBookingsDD",
			requestTitleDD:        "requestTitleDD"
		},
		SearchPage:             {
			searchPageView:              "searchPageView",
			searchResultsAreaContainer:  "searchResultsAreaContainer",
			searchResultsContainer:      "searchResultsContainer",
			searchViewsContainer:        "searchViewsContainer",
			searchErrorContainer:        "searchErrorContainer",
			searchTerm:                  "searchTerm",
			searchTermContainer:         "searchTermContainer",
			reservesSearchTermContainer: "reservesSearchTermContainer",
			databaseTabContainer:        "databaseTabContainer",
			databaseTabs:                "databaseTabs",
			alternateTabs:               "alternateTabs",
			ratingsSuffix:               "results_ratingsControl_",
			flowViewRatings:             "flowView_ratingsControl_",
			bookJacketSuffix:            "_bookJacket",
			bookJacketSuggestionsSuffix: "_bookJacket_suggestion",
			searchUtilities:             "searchUtilities",
			facetsContainer:             "facetsContainer",
			audienceControl:             "audienceControl",
			reservesFilterControl:       "reservesFilterControl",
			facets:                      "facets",
			facetBreadCrumbs:            "facetBreadCrumbs",
			breadCrumbsContainer:        "breadCrumbsContainer",
			resultsSidePanel:            "resultsSidePanel",
			displayCase:                 "displayCase",
			smartGraphic:                "smartGraphic",
			availabilitySuffix:          "_results_availability",
			resultItemCallAndColl:       "_results_resultItemCallAndColl",
			footerControlsSuffix:        "results_footerControls_",
			saveSearchButton:            "saveSearchButton",
			sortingControl:              "sortingControl",
			sortingControlContainer:     "sortingControlContainer",
			worldBookControl:            "worldBookControl",
			worldBookOptionsContainer:   "worldBookOptionsContainer",
			changeViewControl:           "changeViewControl",
			pagingControls:              "pagingControls",
			pagingControlsContainer:     "pagingControlsContainer",
			currentPage:                 "currentPage",
			totalPages:                  "totalPages",
			prev:                        "prev",
			next:                        "next",
			checkAllResults:             "checkAllResults",
			bulkActionControl:           "bulkActionControl",
			bulkActionControlContainer:  "bulkActionControlContainer",
			Tabs:                        {
				ls2pac:     {key: "ls2pac", displayName: "Titles"},
				britannica: {key: "britannica", displayName: "Britannica"},
				newsbank:   {key: "newsbank", displayName: "NewsBank"},
				ebsco:      {key: "ebsco", displayName: "Ebsco"},
				gale:       {key: "gale", displayName: "Gale"},
				reserves:   {key: "reserves", displayName: "Reserve Items"},
				worldbook:  {key: "worldbook", displayName: "World Book"}
			},
			tabSuffix:                   "_tab",
			tabHitsSuffix:               "_tab_totalHits",
			resultsContentSuffix:        "_resultsContent",
			resultsListSuffix:           "_resultsList",
			result_resource_prefix:      "result_resource_",
			saveSearchButtonContainer:   "saveSearchButtonContainer"
		},
		AdvancedSearchPage:     {
			advancedSearchPageView:             "advancedSearchPageView",
			advancedSearchContainer:            "advancedSearchContainer",
			booleanSearchContainer:             "advanced_booleanSearchContainer",
			row_prefix:                         "row_",
			changeAdvancedSearchLocationFilter: "changeAdvancedSearchLocationFilter",
			advancedSearchRows:                 "advancedSearchRows",
			booleanSearching:                   "boolean",
			reservesSearching:                  "reserves",
			reservesSearchSubmit:               "reservesSearchSubmit",
			booleanSearchTitle:                 "booleanSearchTitle"
		},
		DetailsPage:            {
			// detailsContainer:                "detailsContainer",
			bookJacketSuffix:                "_detailsBookJacket",
			teachingBooksLink:               "_teachingBooksLink",
			teachingBooksForm:               "_teachingBooksForm",
			ratingsSuffix:                   "details_ratingsControl_",
			detailsListAndRequestControls:   "detailsListAndRequestControls",
			detailsPageNavigation:           "detailsPageNavigation",
			fullDetails_subViewContainer:    "fullDetails_subViewContainer",
			marcRecordContainer:             "details_marcRecordContainer",
			details_prev:                    "details_prev",
			details_next:                    "details_next",
			details_tags:                    "details_tags",
			ebscoDetailsContainer:           "ebscoDetailsContainer",
			galeDetailsContainer:            "galeDetailsContainer",
			britannicaDetailsContainer:      "britannicaDetailsContainer"
		},
		FlowViewPage:           {
			flowViewItemContainer: "flowViewItemContainer",
			flowViewItemContent:   "flowViewItemContent",
			bookJacketSuffix:      "flowView_bookJacket_",
			flowViewItemSuffix:    "flowViewContent_",
			flowViewPrev:          "flowViewPrev",
			flowViewNext:          "flowViewNext",
			scrollContainer:       "scrollContainer"
		},
		BrowsePage:             {
			browsePageView: "browsePageView"
		},
		MyAccountPage:          {

			myaccountPageView:     "myaccountPageView",
			myAccountContainer:    "myAccountContainer",
			mainAccountNavigation: "mainAccountNavigation",
			loanCount:             "loanCount",
			overdueCount:          "overdueCount",
			totalBookings:         "totalBookings",
			pendingHolds:          "pendingHolds",
			arrivedHolds:          "arrivedHolds",
			totalLoans:            "totalLoans",
			totalFines:            "totalFines",
			createList:            "myAccount_createNewList",
			userInfoContainer:     "userInfoContainer",
			tabs:                  {
				myLists:            "myLists",
				mySearches:         "mySearches",
				accountActivity:    "accountActivity",
				loans:              "loans",
				holds:              "holds",
				fines:              "fines",
				bookings:           "bookings",
				loanHistory:        "loanHistory",
				accountSettings:    "accountSettings",
				ezLogin:            "updateEZLogin",
				pin:                "updatePin",
				contactInformation: "contactInformation",
				summary:            "accountSummary",
				ezUsername:         "updateEZUsername",
				ezPassword:         "updateEZPassword",
				exportMyData:       "exportMyData",
				linkedAccounts:     "linkedAccountsTab",
				landingPageConfig:  "landingPageConfigTab",
				tagManagement:      "tagManagementTab"
			}
		},
		Controls:               {},
		eResourceCheckouts:     {
			eResourceCheckoutForm:                     "eResourceCheckoutForm",
			eResourceCheckoutSuccessDialog:            "eResourceCheckoutSuccessDialog",
			eResourceHoldForm:                         "eResourceHoldForm",
			eResourceFormatSelectionForm:              "eResourceFormatSelectionForm",
			eResourceDownloadAgainSuccessDialog:       "eResourceDownloadAgainSuccessDialog",
			eResourceFormatSelectionDialog:            "eResourceFormatSelectionDialog"
		},
		speech:                 {
			container: "speechContainer",
			details:   "speechDetails"
		}
	},
	MyAccountPrintTypes:  {
		accountSummary: "accountSummary",
		loans:          "loans",
		holds:          "holds",
		fines:          "fines",
		bookings:       "bookings",
		loanHistory:    "loanHistory"
	},
	CssClasses:           {
		activeView:                   "activeView",
		selected:                     "selected",
		active:                       "active",
		current:                      "current",
		content:                      "content",
		disabled:                     "disabled",
		map:                          "map",
		availabilityLink:             "availabilityLink",
		availabilityBindClass:        "availabilityBind",
		imageByAmazon:                "imageByAmazon",
		fullDetails:                  "fullDetails",
		series:                       "series",
		authorLink:                   "authorLink",
		tagLink:                      "tagLink",
		copies:                       "copies",
		reviews:                      "reviews",
		moreSummary:                  "moreSummary",
		open:                         "open",
		advancedSearchField:          "advancedSearchField",
		advancedSearchType:           "advancedSearchType",
		advancedSearchString:         "advancedSearchString",
		advancedSearch:               "advancedSearch",
		booleanSearch:                "booleanSearch",
		reservesSearch:               "reservesSearch",
		readingLevelSearch:           "readingLevelSearch",
		keywordSearch:                "keywordSearch",
		hidden:                       "hidden",
		searchButton:                 "searchButton",
		reset:                        "reset",
		advancedFormRow:              "advancedFormRow",
		minus:                        "minus",
		plus:                         "plus",
		parts:                        "parts",
		volumeAndCopy:                "volumeAndCopy",
		tooltip:                      "tooltip",
		requestCopyCheckbox:          "requestCopyCheckbox",
		holdingsSection:              "dataTable",
		shelfLocation:                "shelfLocation",
		toggleButton:                 "toggleButton",
		external:                     "external",
		eResource:                    "eResource",
		refreshDigitalLoans:          "refreshDigitalLoans",
		refreshDigitalLoansContainer: "refreshDigitalInfoContainer",
		date:                         "date"
	},
	DetailPages:          {
		fullDetails:           "fullDetailsDetailsTab",
		allCopies:             "allCopiesDetailsTab",
		reviews:               "reviewsDetailsTab",
		related:               "relatedDetailsTab",
		lookInside:            "lookInsideDetailsTab",
		marcRecord:            "marcRecordDetailsTab",
	},
	EResourceFormats:     {
		acoustik: "Acoustik",
		blio:     "Blio"
	},
	BulkActionTypes:      {
		Request:   {
			key: "request"
		},
		AddToList: {
			key: "addToList"
		}
	},
	RecentAdditionsRange: [
		{
			display: "This Week",
			key:     "ThisWeek"
		},
		{
			display: "Last Two Week",
			key:     "LastTwoWeeks"
		},
		{
			display: "Last Three Weeks",
			key:     "LastThreeWeeks"
		},
		{
			display: "Last Month",
			key:     "LastMonth"
		},
		{
			display: "Last Three Months",
			key:     "LastThreeMonths"
		},
		{
			display: "Last Six Months",
			key:     "LastSixMonths"
		},
		{
			display: "Last Year",
			key:     "LastYear"
		}
	],
	advancedSearchViews:  {
		advancedSearchPage:    "advancedSearchPage",
		booleanSearching:      "boolean",
		reservesSearching:     "reserves",
		readingLevelSearching: "readingLevels"
	},
	obrViews:             {
		obrPage: "obrPage"
	},
	searchFields:         {
		title:    'title',
		author:   'author',
		subject:  'subject',
		advanced: 'advanced',
		reserves: 'reserves'
	},
	searchTypeKeys:       {
		BeginsWith:  "BeginsWith",
		Contains:    "Contains",
		ExactMatch:  "ExactMatch",
		NotContains: "NotContains"
	},
	searchFieldKeys:      {
		AnyField:   "AnyField",
		Title:      "Title",
		Author:     "Author",
		Series:     "Series",
		Subject:    "Subject",
		Note:       "Note",
		Tag:        "Tag",
		ISBN:       "ISBN",
		ISSN:       "ISSN",
		UPC:        "UPC",
		CallNumber: "CallNumber"
	},
	restUrls:             {
		availability:                 "availability",
		addObrPatron:                 "account/add",
		search:                       "search",
		searchCount:                  "search/count",
		eResourceAvailability:        "eResource/availability",
		eResourceCheckout:            "eResource/checkout",
		eResourcePlaceHold:           "eResource/placeHold",
		eResourceRemoveHold:          "eResource/removeHold",
		eResourceRenew:               "eResource/renew",
		eResourceReturn:              "eResource/return",
		ebscoSearch:                  "ebsco/search",
		ebscoSearchCount:             "ebsco/search/count",
		ebscoSorts:                   "ebsco/sorts",
		getBranchLimits:              "branch/branchLimits",
		getFacetResults:              "facets/getFacetResults",
		getMoreFacetResults:          "facets/getMoreFacetResults/",
		getLocationConfiguration:     "locationConfiguration/getIfChanged",
		getGlobalConfigurationFields: "globalConfiguration/fields",
		getSupportedFunctionality:    "hostSystem/supportedFunctionality",
		marc21Display:                "marc21DisplayManager/getRecord",
		stationLocation:              "stationLocation/thisBranch",
		addTag:                       "tag",
		removeTag:                    "tag/remove",
		fullDetails:                  "resource/details/",
		getResourceById:              "resource",
		getResourceByHostRecordId:    "resource/byHostRecordId",
		getSpellingSuggestions:       "search/spellingSuggestions",
		getSearchSuggestions:         "search/searchSuggestions",
		getAccountSummary:            "account/summary",
		getDependentAccountSummaries: "account/summary/dependents",
		getCurrentLoans:              "loans",
		renewLoans:                   "loans/renew",
		getHolds:                     "requests",
		getHoldsCount:                "requests/count",
		cancelHolds:                  "requests/cancel",
		suspendHolds:                 "requests/suspend",
		unsuspendHolds:               "requests/unsuspend",
		getLoanHistory:               "loans/history",
		getTotalLoanHistoryCount:     "loans/history/count",
		getLoanHistoryByDateRange:    "loans/history/byDateRange",
		getBookings:                  "bookings",
		placeBookings:                "bookings",
		getBookingsCount:             "bookings/count",
		cancelBookings:               "bookings/cancel",
		getFines:                     "fees",
		getStaticLists:               "lists/static",
		getStaticListCount:           "list/count/static",
		getStaticConfigListCount:     "list/count/static/config",
		getDynamicListCount:          "list/count/dynamic",
		getDynamicConfigListCount:    "list/count/dynamic/config",
		getStaticListContent:         "list/static",
		getDynamicConfigLists:        "lists/dynamic/config",
		getDynamicLists:              "lists/dynamic",
		getAllTags:                   "tag/allTags",
		getAllTagsCount:              "tag/allTags/count",
		savePrivateDynamicList:       "list/dynamic",
		savePublicDynamicList:        "list/dynamic/config",
		savePrivateStaticList:        "list/static",
		savePublicStaticList:         "list/static/config",
		addToList:                    "list/static",
		removeFromList:               "list/static",
		deleteLists:                  "lists/delete",
		renameList:                   "list",
		unlinkGoogleAccount:          "account/update/unlinkGoogleAccount",
		updateContactInformation:     "account/update/contactInformation",
		updatePin:                    "account/update/pin",
		updateUsername:               "account/update/username",
		updatePassword:               "account/update/password",
		updateEZLogin:                "account/update/ezLogin",
		reviewTitle:                  "reviews",
		getReviews:                   "reviews",
		removeReview:                 "reviews",
		requests:                     "requests/",
		language:                     "language/",
		logout:                       "logout",
		login:                        "login",
		isAuthenticated:              "isAuthenticated",
		currentUser:                  "currentUser",
		getStoredImagesByCategory:    "storedimage/byCategory/",
		saveNewLogo:                  "storedimage/",
		setNoLogo:                    "storedimage/nologo",
		removeStoredImage:            "storedimage/",
		uploadLogo:                   "storedimage/logos",
		forgotPassword:               "account/reset/password",
		eResourceRefresh:             "pacApi/updateHistory",
		readingLevelOptions:          "readingLevel/getInfo"
	}
};
